import { View, Text } from "react-native";
import { OfflineRequestStatusModel } from "../../../services/api/types/offline/models/OfflineRequestStatusModel";
import { SyncingRequestStatusEnum } from "../../../services/api/types/offline/enums/SyncingRequestStatusEnum";

export interface Props {
  data?: OfflineRequestStatusModel[];
}
export function SyncSummary({ data }: Props) {
  const totalPendingActions = data ? data.length : null;
  const hasPendingActions = data?.some(
    (action) => action.status === SyncingRequestStatusEnum.PROCESSING,
  );
  let statusText = "";
  let completedActionCount = 0;
  let failedActionCount = 0;

  if (hasPendingActions) {
    statusText = "Syncing";
  } else {
    data?.forEach((action) => {
      if (action.status === SyncingRequestStatusEnum.COMPLETED)
        completedActionCount += 1;
      else if (action.status === SyncingRequestStatusEnum.FAILED)
        failedActionCount += 1;
    });
    statusText = `${completedActionCount} Completed ${failedActionCount} Failed`;
  }

  return (
    <View className="gap-4">
      <Text className="text-base font-medium text-typography-600">
        Sync Summary
      </Text>
      <View className="grid grid-cols-2 gap-y-6">
        <Text className="text-base text-typography-500">
          Total pending actions
        </Text>
        <Text className="text-base text-typography-900">
          {totalPendingActions}
        </Text>
        <Text className="text-base text-typography-500">Status</Text>
        <Text className="text-base text-typography-900">{statusText}</Text>
      </View>
    </View>
  );
}
